<template>
  <div class="forum-hanlenav">
    <div class="functional-classification">
      <div>
        <span class="post-selection show-flex-box-c">
          <span class="my-post show-flex-box-r">
            <span class="my-post-pic"></span>
            <strong :class= "{'selected':myPostClass == true}" v-if= "forumKinds" @click= "myPost">我的帖子</strong>
          </span>
          <span class="segmenting-line"></span>
          <span class="my-response">
            <span class="my-response-pic"></span>
            <strong :class= "{'selected':myReplyClass == true}" v-if= "forumKinds" @click= "myReply">我回复的</strong>
          </span>
        </span>
        <span class="send-post show-flex-box-r" @click= "postMessage">
          <span></span>
          <strong>发布帖子</strong>
        </span>
      </div>
      <post-message ref="postMessagePop" :forumKind= 'forumKinds'></post-message>
    </div>
  </div>
</template>

<script>
import postMessage from "@/components/post_message/post_message"

export default {
  name: 'forum_hanlenav_cpn',
  props:{
    'forumKinds': [Object,String],
    'myPostClass': [Boolean,String],
    'myReplyClass': [Boolean,String]
  },
  data () {
    return {
      routerInfo: ''
    }
  },
  components: {
    postMessage
  },
  created() {
    this.routerInfo = this.$route.params.type;
  },
  methods: {
    myPost: function() {
      let userToken = this.$store.state.token;
      if (userToken && userToken != 'false') {
        if (this.routerInfo == 'forum') {
          let path = '/forum/personal/my_post/forum';
          this.$router.push({'path':path,query: {forumKind: this.forumKinds,myPostClass: true}});
        } else {
          let path = '/mars_box_ins/personal/my_post/teacherForum';
          this.$router.push({'path':path,query: {forumKind: this.forumKinds,myPostClass: true}});
        }
      } else {
        this.$elementMsg.error({
          'message': '您还没有登录，请登录',
          'showClose':true,
          'customClass': 'pop-class-error',
          'duration': 3000
        });
        let toWhere = '/index';
        this.$router.push({'path':toWhere});
      }
    },
    myReply: function() {
      let userToken = this.$store.state.token;

      if (userToken && userToken != 'false') {
        if (this.routerInfo == 'forum') {
          let path = '/forum/personal/my_reply/forum';
          this.$router.push({'path':path,query: {forumKind: this.forumKinds,myReplyClass: true}});
        } else {
          let path = '/mars_box_ins/personal/my_reply/teacherForum';
          this.$router.push({'path':path,query: {forumKind: this.forumKinds,myReplyClass: true}});
        }
      } else {
        this.$elementMsg.error({
          'message': '您还没有登录，请登录',
          'showClose':true,
          'customClass': 'pop-class-error',
          'duration': 3000
        });
        let toWhere = '/index';
        this.$router.push({'path':toWhere});
      }
    },
    postMessage: function() {
      let userToken = this.$store.state.token;
      if (userToken && userToken != 'false') {
        this.$refs.postMessagePop.showOrhidePop();
      } else {
        this.$elementMsg.error({
          'message': '您还没有登录，请登录',
          'showClose':true,
          'customClass': 'pop-class-error',
          'duration': 3000
        });
        let toWhere = '/index';
        this.$router.push({'path':toWhere});
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .forum-hanlenav{
    .functional-classification{
      width: 310px;
      border-radius: 10px;
      div{
        .post-selection{
          display: flex;
          width: 310px;
          height: 100px;
          border-radius: 10px;
          align-items: center;
          background: #fff;
          .my-post{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 310px;
            height: 60px;
            cursor: pointer;
            .my-post-pic{
              display: block;
              width: 20px;
              height: 20px;
              background: url('../../assets/forum/my_post.png') no-repeat center center;
              background-size: 20px 20px;
            }
            strong{
              display: block;
              font-size: 18px;
              font-weight: 400;
              line-height: 30px;
              color: #555;
              padding-left: 10px;
            }
            strong:hover{
              color: #ff7800;
            }
            .selected{
              color: #ff7800;
            }
          }
          .segmenting-line{
            display: block;
            width: 236px;
            height: 1px;
            background: #f5f5f5;
          }
          .my-response{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 310px;
            height: 60px;
            cursor: pointer;
            .my-response-pic{
              display: block;
              width: 20px;
              height: 20px;
              background: url('../../assets/forum/my_response.png') no-repeat center center;
              background-size: 20px 20px;
            }
            strong{
              display: block;
              font-size: 18px;
              font-weight: 400;
              color: #555;
              padding-left: 10px;
              line-height: 30px;
            }
            strong:hover{
              color: #ff7800;
            }
            .selected{
              color: #ff7800;
            }
          }
        }
        .send-post{
          display: flex;
          width: 310px;
          height: 50px;
          border-radius: 10px;
          background: #ff7800;
          justify-content: center;
          align-items: center;
          margin-top: 10px;
          cursor: pointer;
          span{
            display: block;
            width: 20px;
            height: 20px;
            background: url('../../assets/forum/send_post.png') no-repeat center center;
            background-size: 20px 20px;
          }
          strong{
            display: block;
            font-size: 19px;
            font-weight: 400;
            color: #fff;
            padding-left: 10px;
            line-height: 20px;
          }
        }
        .send-post:hover{
          background: #ffa93b;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/forum/forum_hanlenav_cpn.vue